import React from 'react';
import styled from 'styled-components';
import Modal from '../../containers/common/Modal';

const Backdrop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
`;

const Sheet = styled.div`
  width: 90%;
  max-width: 400px;
  max-height: 85%;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const Fixed = styled.div`
  flex-shrink: 0;
`;

const Points = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export default function ClaimInstructionsModal({
  instructions = [],
  checklists = [],
  onChecklistTap,
  onClose,
}) {
  if (!instructions.length) return null;
  return (
    <Modal>
      <Backdrop>
        <Sheet>
          <Fixed className="flex justify-center py-24px text-body-l font-semibold text-modalTitleTextColor bg-buttonLight rounded-8">
            Please Note
          </Fixed>
          <Fixed className="p-16px flex justify-center text-body-s text-darkBlue">
            IMPORTANT INSTRUCTIONS
          </Fixed>
          <Points className="mx-16px p-20px bg-buttonLight rounded-8">
            {instructions.map((item) =>
              item.point ? (
                <p key={item.point} className="text-card-body mb-8px flex">
                  <span className="mr-4px">{item.point}.</span>
                  <span>{item.description}</span>
                </p>
              ) : null
            )}
          </Points>
          {checklists?.map((checklist) => (
            <Fixed key={checklist.docUrl} className="px-16px pt-16px">
              <button
                onClick={() => onChecklistTap && onChecklistTap(checklist)}
                className="w-full border border-primary flex justify-center py-14px items-center rounded-8 text-card-body text-primary font-semibold"
              >
                {checklist.name}
              </button>
            </Fixed>
          ))}
          <Fixed className="px-16px py-24px">
            <button
              onClick={onClose}
              className="w-full bg-primary py-14px text-body-s font-semibold rounded-8 text-textbox"
            >
              Got it!
            </button>
          </Fixed>
        </Sheet>
      </Backdrop>
    </Modal>
  );
}
